/* 詳細画面 保証人(近代資金メイン) */
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { useCallApi } from '../../hooks/CallApi';
import useFetchReceptionData from '../../hooks/FetchReceptionData';
import ContentInquiryFinal from './ContentInquiryFinal';
import ModernisationFundingContractContentConfirm from '../applicant/ModernisationFundingContractContentConfirm';
import { KDANKGM05010A01, KDANKGM05010A02 } from '../../const/api_modules';
import { FixedValuesContext } from '../../context/FixedValues';
import useLazyLoad from '../../hooks/LazyLoad';
import { hasErrorMessage } from '../../Common';
import ContentInquiryModernizationFundsMain from './ContentInquiryModernizationFundsMain';
import {
  KWANKGM04290A01,
  KWANKGM04290A02,
  KWANKGM04330A01,
  KWANKGM04330A02,
} from '../../const/api_modules';
import ExaminationChange from './ExaminationChange';
import { mp_flg as mp_flg_value, ma_flg as ma_flg_value } from '../../Const';
import ModernisationFundingCaseDetails from '../applicant/ModernisationFundingCaseDetails';

const AppModernizationFundsMain: React.FC = () => {
  // ローディング画面制御
  const [is_loading, setIsLoading] = useState(false);
  const {
    // ヘッダ
    label,
    guide_text,
    step_navigation,
    display_reception_cd,
    display_status,
    // 詳細画面情報
    parent_shelfs,
    child_shelfs,
    contents,
    // 固定パラメータ
    status_name,
    status_code,
    loan_type,
    reception_id,
    reception_cd,
    reception_sub_cd,
    ident_lv1_cd,
    ident_lv2_cd,
    ident_lv3_cd,
    ja_name,
    opened_mypage,
    is_staff,
    applied,
    is_change,
    has_debtor,
    is_disagree,
    change_request_message,
    guarantors_num,
    sign_info,
    is_signed,
    agreements,
    guarantor_info,
    review_approval_status,
    is_checked_contract_document,
    review_approval_status_name,
    review_message,
    agreement_info,
    has_loan_approval,
    mp_flg,
    ma_flg,
    is_bank_exists,
    is_desired_bank_exists,
    is_ja_exists,
    online_identification_modal_open,
    is_guarantor_agreement,
    is_implement_online_identification,
    // ファイルアップローダ
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    shelf_info_j,
    shelf_info_k,
    shelf_info_aa,
    shelf_info_ab,
    shelf_info_ac,
    shelf_info_ad,
    shelf_info_ae,
    shelf_info_af,
    shelf_info_ag,
    shelf_info_ah,
    shelf_info_ai,
    shelf_info_aj,
    shelf_info_ak,
    shelf_info_al,
    shelf_info_am,
    shelf_info_an,
    shelf_info_ao,
    shelf_info_ap,
    shelf_info_aq,
    shelf_info_ar,
    shelf_info_as,
    shelf_info_at,
    shelf_info_au,
    shelf_info_av,
    shelf_info_aw,
    shelf_info_ax,
    shelf_info_ay,
    shelf_info_az,
    shelf_info_ba,
    shelf_info_bb,
    shelf_info_bc,
    shelf_info_bd,
    shelf_info_be,
    shelf_info_bf,
    shelf_info_bg,
    shelf_info_bh,
    shelf_info_bi,
    // お客様へのお知らせ
    info_notice_contract_confirm,
    // 辞退ボタンの活性フラグ
    is_active_decline_btn,
    is_corporate_user,
    is_agricultural_modernization_funds,
    is_signer,
    // ディスパッチ
    setParentShelfs,
    setChildShelfs,
    setContents,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    setShelfInfoJ,
    setShelfInfoK,
    setShelfInfoAA,
    setShelfInfoAB,
    setShelfInfoAC,
    setShelfInfoAD,
    setShelfInfoAE,
    setShelfInfoAF,
    setShelfInfoAG,
    setShelfInfoAH,
    setShelfInfoAI,
    setShelfInfoAJ,
    setShelfInfoAK,
    setShelfInfoAL,
    setShelfInfoAM,
    setShelfInfoAN,
    setShelfInfoAO,
    setShelfInfoAP,
    setShelfInfoAQ,
    setShelfInfoAR,
    setShelfInfoAS,
    setShelfInfoAT,
    setShelfInfoAU,
    setShelfInfoAV,
    setShelfInfoAW,
    setShelfInfoAX,
    setShelfInfoAY,
    setShelfInfoAZ,
    setShelfInfoBA,
    setShelfInfoBB,
    setShelfInfoBC,
    setShelfInfoBD,
    setShelfInfoBE,
    setShelfInfoBF,
    setShelfInfoBG,
    setShelfInfoBH,
    setShelfInfoBI,
    setDisplayStatus,
    // 関数
    moveStepNav,
    setLabel,
    setStepNavigation,
    setOnlineIdentificationModalOpen,
    setIsImplementOnlineIdentification,
    setIsGuarantorAgreement,
  } = useFetchReceptionData(setIsLoading);

  // API呼び出し処理
  const { setShowErrorNav, show_error_nav, api_response_detail, requestModule } = useCallApi(
    child_shelfs,
    contents,
    setContents,
    setChildShelfs,
    reception_id,
    reception_cd,
    status_code,
    is_staff,
    setIsLoading,
    guarantor_info,
    setOnlineIdentificationModalOpen
  );

  // 書類画像の遅延ロード
  useLazyLoad(
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    shelf_info_j,
    shelf_info_k,
    shelf_info_aa,
    shelf_info_ab,
    shelf_info_ac,
    shelf_info_ad,
    shelf_info_ae,
    shelf_info_af,
    shelf_info_ag,
    shelf_info_ah,
    shelf_info_ai,
    shelf_info_aj,
    shelf_info_ak,
    shelf_info_al,
    shelf_info_am,
    shelf_info_an,
    shelf_info_ao,
    shelf_info_ap,
    shelf_info_aq,
    shelf_info_ar,
    shelf_info_as,
    shelf_info_at,
    shelf_info_au,
    shelf_info_av,
    shelf_info_aw,
    shelf_info_ax,
    shelf_info_ay,
    shelf_info_az,
    shelf_info_ba,
    shelf_info_bb,
    shelf_info_bc,
    shelf_info_bd,
    shelf_info_be,
    shelf_info_bf,
    shelf_info_bg,
    shelf_info_bh,
    shelf_info_bi,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    setShelfInfoJ,
    setShelfInfoK,
    setShelfInfoAA,
    setShelfInfoAB,
    setShelfInfoAC,
    setShelfInfoAD,
    setShelfInfoAE,
    setShelfInfoAF,
    setShelfInfoAG,
    setShelfInfoAH,
    setShelfInfoAI,
    setShelfInfoAJ,
    setShelfInfoAK,
    setShelfInfoAL,
    setShelfInfoAM,
    setShelfInfoAN,
    setShelfInfoAO,
    setShelfInfoAP,
    setShelfInfoAQ,
    setShelfInfoAR,
    setShelfInfoAS,
    setShelfInfoAT,
    setShelfInfoAU,
    setShelfInfoAV,
    setShelfInfoAW,
    setShelfInfoAX,
    setShelfInfoAY,
    setShelfInfoAZ,
    setShelfInfoBA,
    setShelfInfoBB,
    setShelfInfoBC,
    setShelfInfoBD,
    setShelfInfoBE,
    setShelfInfoBF,
    setShelfInfoBG,
    setShelfInfoBH,
    setShelfInfoBI,
    is_loading,
    status_code
  );
  // エラーナビゲーション制御
  const [has_valid_error, setHasValidError] = useState(false);

  useEffect(() => {
    setHasValidError(hasErrorMessage(contents));
  }, [contents]);

  return (
    <Router>
      {/* TODO sakuma 固定値はすべてこちらのContextを見るように修正する */}
      <FixedValuesContext.Provider
        value={{
          has_loan_approval: has_loan_approval,
          has_review_approval_status: review_approval_status,
        }}
      >
        <Switch>
          {/* KWANKGM04060_借入申込同意不同意（受付完了） */}
          {/* 同意の場合 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(2400|2500|2610|2910)/agree">
            <ContentInquiryFinal
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
            />
          </Route>
          {/* 不同意の場合 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(2400|2500|2610|2910)/disagree">
            <ContentInquiryFinal
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
            />
          </Route>
          {/* 借入申込中 */}
          <Route exact path="/reception/:reception_cd/:reception_id/2300">
            <ExaminationChange
              guide_text={''}
              label={label}
              reception_cd={''}
              status_name={''}
              display_reception_cd={false}
              display_status={false}
              is_loading={is_loading}
            />
          </Route>
          {/* KWANKGM04290_近代化資金 確認(連帯債務者等) */}
          <Route
            exact
            path="/reception/:reception_cd/:reception_id/(2400|2500|2610|2900|2910|3000|93050|3100|3400)"
          >
            <ContentInquiryModernizationFundsMain
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              step_navigation={step_navigation}
              looks_inactive={false} // 入力可否
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              reception_id={reception_id}
              status_code={status_code}
              agreements={agreements}
              guarantors_num={guarantors_num}
              guarantor_info={guarantor_info}
              show_error_nav={has_valid_error || show_error_nav}
              display_status={display_status}
              is_loading={is_loading}
              is_disagree={is_disagree}
              setShowErrorNav={setShowErrorNav}
              mp_flg={mp_flg}
              ma_flg={ma_flg}
              callApi={requestModule}
              clickAgree={() => requestModule(KWANKGM04290A01)}
              clickDisagree={() => requestModule(KWANKGM04290A02)}
              is_bank_exists={is_bank_exists}
              is_desired_bank_exists={is_desired_bank_exists}
              is_ja_exists={is_ja_exists}
              setIsLoading={setIsLoading}
              modal_open={online_identification_modal_open}
              setModalnOpen={setOnlineIdentificationModalOpen}
              is_guarantor_agreement={is_guarantor_agreement}
              is_implement_online_identification={is_implement_online_identification}
              setIsImplementOnlineIdentification={setIsImplementOnlineIdentification}
              setIsGuarantorAgreement={setIsGuarantorAgreement}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
              is_corporate_user={is_corporate_user}
            />
          </Route>
          {/* KDANKGM05050_近代化資金契約書内容確認（連帯債務者等） */}
          <Route exact path="/reception/:reception_cd/:reception_id/(3500|3600|3700|3800|3900)">
            <ModernisationFundingContractContentConfirm
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              reception_id={reception_id}
              status_code={status_code}
              sign_info={sign_info}
              guarantor_info={guarantor_info}
              display_status={display_status}
              is_signed={guarantor_info.is_signed}
              mp_flg={mp_flg}
              handleDecline={() => requestModule(KDANKGM05010A01)} // 辞退する
              handleExecution={() => requestModule(KDANKGM05010A02)} // 契約手続きに進む
              is_loading={is_loading}
              is_checked_contract_document={is_checked_contract_document}
              info_notice={info_notice_contract_confirm}
              is_active_decline_btn={is_active_decline_btn}
              is_signer={is_signer}
            />
          </Route>
          {/* KWANKGM04330_近代化資金案件詳細（マイページ） */}
          <Route exact path="/reception/:reception_cd/:reception_id/4100">
            <ModernisationFundingCaseDetails
              step_navigation={step_navigation}
              reception_id={reception_id}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              status_code={status_code}
              is_staff={is_staff}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              agreement_info={agreement_info}
              sign_info={sign_info}
              review_approval_status_name={review_approval_status_name}
              review_message={review_message}
              is_guarantor={guarantor_info.is_guarantor}
              mp_flg={mp_flg}
              ma_flg={ma_flg}
              handleDecline={() => requestModule(KWANKGM04330A01)} //『辞退する』のモジュール
              handleExecution={() => requestModule(KWANKGM04330A02)} //『申込内容を変更する』のモジュール
              is_signer={is_signer}
            />
          </Route>
        </Switch>
      </FixedValuesContext.Provider>
    </Router>
  );
};

if (document.getElementById('template-guarantor-modernization-funds-main')) {
  ReactDOM.render(
    <AppModernizationFundsMain />,
    document.getElementById('template-guarantor-modernization-funds-main')
  );
}
